// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoriesList {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-top: 1rem;
  border: none;
  background: none;
}
@media (min-width: 768px) {
  .CategoriesList {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.CategoriesList .CategoriesList-Empty {
  grid-column: 1/-1;
  padding: 3rem 0;
  color: var(--bs-gray-600);
}
.CategoriesList .CategoriesListItem {
  box-shadow: 1px 2px 2.3px 2px rgba(0, 0, 0, 0.07);
  border: none;
  border-radius: 10px !important;
  margin: 0 !important;
  padding: 1rem 1.25rem;
}
.CategoriesList .CategoriesListItem .CategoriesListItem-Header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}
.CategoriesList .CategoriesListItem .CategoriesListItem-Header .CategoriesListItem-ColorPreview {
  width: 28px;
  height: 28px;
  border-radius: 0.3rem;
  flex-shrink: 0;
}
.CategoriesList .CategoriesListItem .CategoriesListItem-Header .CategoriesListItem-Info {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  margin-right: auto;
}
.CategoriesList .CategoriesListItem .CategoriesListItem-Header .CategoriesListItem-Info .CategoriesListItem-Name {
  font-weight: 700;
  font-size: 1.1rem;
  color: var(--bs-primary);
}
.CategoriesList .CategoriesListItem .CategoriesListItem-Header .CategoriesListItem-Info .CategoriesListItem-Questions {
  color: var(--bs-gray-600);
  font-size: 0.95rem;
}
.CategoriesList .CategoriesListItem .CategoriesListItem-Header .CategoriesListItem-Actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}
.CategoriesList .CategoriesListItem .CategoriesListItem-Description {
  color: var(--bs-body-color);
}
.CategoriesList .CategoriesListItem .CategoriesListItem-Groups {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.75rem;
}
.CategoriesList .CategoriesListItem .CategoriesListItem-IconButton {
  background: none;
  border: none;
  padding: 0.25rem;
  margin: 0;
  line-height: 1;
  border-radius: 0.25rem;
  color: var(--bs-primary);
  text-decoration: none;
}
.CategoriesList .CategoriesListItem .CategoriesListItem-IconButton i {
  font-size: 14px;
  pointer-events: none;
}
.CategoriesList .CategoriesListItem .CategoriesListItem-IconButton:hover, .CategoriesList .CategoriesListItem .CategoriesListItem-IconButton:focus-visible {
  background-color: rgba(var(--bs-primary-rgb), 0.1);
}
.CategoriesList .CategoriesListItem .CategoriesListItem-IconButton:focus-visible {
  outline: 2px solid var(--bs-primary);
  outline-offset: 2px;
}
.CategoriesList .CategoriesListItem .CategoriesListItem-IconButton--danger {
  color: var(--bs-danger);
}
.CategoriesList .CategoriesListItem .CategoriesListItem-IconButton--danger:hover, .CategoriesList .CategoriesListItem .CategoriesListItem-IconButton--danger:focus-visible {
  background-color: rgba(var(--bs-danger-rgb), 0.1);
}
.CategoriesList .CategoriesListItem .CategoriesListItem-IconButton--danger:focus-visible {
  outline-color: var(--bs-danger);
}`, "",{"version":3,"sources":["webpack://./src/features/Settings/pages/Categories/components/CategoriesList/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AACF;AACE;EARF;IASI,gDAAA;EAEF;AACF;AAAE;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;AAEJ;AAGE;EACE,iDAAA;EACA,YAAA;EACA,8BAAA;EACA,oBAAA;EACA,qBAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AADN;AAGM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;AADR;AAIM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAFR;AAIQ;EACE,gBAAA;EACA,iBAAA;EACA,wBAAA;AAFV;AAKQ;EACE,yBAAA;EACA,kBAAA;AAHV;AAOM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AALR;AASI;EACE,2BAAA;AAPN;AAUI;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AARN;AAWI;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;AATN;AAWM;EACE,eAAA;EACA,oBAAA;AATR;AAYM;EAEE,kDAAA;AAXR;AAcM;EACE,oCAAA;EACA,mBAAA;AAZR;AAeM;EACE,uBAAA;AAbR;AAeQ;EAEE,iDAAA;AAdV;AAiBQ;EACE,+BAAA;AAfV","sourcesContent":[".CategoriesList {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n  margin-top: 1rem;\n  border: none;\n  background: none;\n\n  @media (min-width: 768px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .CategoriesList-Empty {\n    grid-column: 1 / -1;\n    padding: 3rem 0;\n    color: var(--bs-gray-600);\n  }\n\n  // Overrides for the underlying bootstrap .list-group-item: this is a grid of\n  // cards, not a stacked list, so none of the adjacency-based border/margin rules apply.\n  .CategoriesListItem {\n    box-shadow: 1px 2px 2.3px 2px rgba(0, 0, 0, 0.07);\n    border: none;\n    border-radius: 10px !important;\n    margin: 0 !important;\n    padding: 1rem 1.25rem;\n\n    .CategoriesListItem-Header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 0.75rem;\n      margin-bottom: 0.75rem;\n\n      .CategoriesListItem-ColorPreview {\n        width: 28px;\n        height: 28px;\n        border-radius: 0.3rem;\n        flex-shrink: 0;\n      }\n\n      .CategoriesListItem-Info {\n        display: flex;\n        flex-direction: column;\n        gap: 0.15rem;\n        margin-right: auto;\n\n        .CategoriesListItem-Name {\n          font-weight: 700;\n          font-size: 1.1rem;\n          color: var(--bs-primary);\n        }\n\n        .CategoriesListItem-Questions {\n          color: var(--bs-gray-600);\n          font-size: 0.95rem;\n        }\n      }\n\n      .CategoriesListItem-Actions {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        flex-shrink: 0;\n      }\n    }\n\n    .CategoriesListItem-Description {\n      color: var(--bs-body-color);\n    }\n\n    .CategoriesListItem-Groups {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.35rem;\n      margin-top: 0.75rem;\n    }\n\n    .CategoriesListItem-IconButton {\n      background: none;\n      border: none;\n      padding: 0.25rem;\n      margin: 0;\n      line-height: 1;\n      border-radius: 0.25rem;\n      color: var(--bs-primary);\n      text-decoration: none;\n\n      i {\n        font-size: 14px;\n        pointer-events: none;\n      }\n\n      &:hover,\n      &:focus-visible {\n        background-color: rgba(var(--bs-primary-rgb), 0.1);\n      }\n\n      &:focus-visible {\n        outline: 2px solid var(--bs-primary);\n        outline-offset: 2px;\n      }\n\n      &--danger {\n        color: var(--bs-danger);\n\n        &:hover,\n        &:focus-visible {\n          background-color: rgba(var(--bs-danger-rgb), 0.1);\n        }\n\n        &:focus-visible {\n          outline-color: var(--bs-danger);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
